import { render } from "./Layout5.vue.js?vue&type=template&id=73718a12!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Layout5.vue?vue&type=template&id=73718a12"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__